import React from "react";
import { useNavigate } from "react-router-dom";

export const Navigation = (props) => {
  const {
    id,
    hospitalId,
    isFirstLong,
    titleTabPosition = "justify-center",
    isDisabled = false,
  } = props;

  const tabs = [
    {
      title: "병원 정보",
      id: "detail",
    },
    {
      title: "환자 목록",
      id: "patient",
    },
    {
      title: "주문내역",
      id: "order",
    },
    {
      title: "포인트",
      id: "point",
    },
    {
      title: "1:1 문의",
      id: "1on1",
    },
    {
      title: "상품 문의",
      id: "inquiry",
    },
    {
      title: "상품 리뷰",
      id: "review",
    },
  ];

  const navigate = useNavigate();
  const onChangeTab = (id) => {
    navigate(`/hospital/${hospitalId}/${id}`);
  };
  return (
    <div>
      <div className="mt-4 w-full border-b-2 border-black">
        <ul className="flex overflow-auto no-scrollbar">
          {tabs?.map((val) => {
            return (
              <li
                key={val.id}
                className={`${
                  val?.totalData ? "" : "flex justify-center"
                } cursor-pointer py-2 px-2 rounded-t-lg text-center ${
                  id === val.id
                    ? "bg-primary-blue text-white font-bold"
                    : "bg-white border border-[#ddd] text-[#aaaaaa]"
                } w-45`}
                onClick={isDisabled ? null : () => onChangeTab(val.id)}
              >
                <div
                  className={`flex w-20 ${
                    isFirstLong ? (val?.id - 1 ? "px-4" : "px-10") : ""
                  } ${titleTabPosition} items-center`}
                >
                  <span>{val?.title}</span>
                  {val?.totalData ? (
                    <span
                      className={`font-bold ${
                        id === val?.id ? "text-white" : "text-black"
                      }`}
                    >
                      {val?.totalData}
                    </span>
                  ) : null}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Navigation;
